(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-article"]) return;
  try {
    
  function normalizePaleonArticle(root) {
    const body = root.querySelector('[data-paleon-article-body]');
    if (!body) return;

    const topLevelBlock = function(element) {
      let node = element;
      while (node.parentElement && node.parentElement !== body) {
        node = node.parentElement;
      }
      return node;
    };

    const imageBlocks = [];
    const seen = new Set();

    body.querySelectorAll('img').forEach(function(image) {
      const block = topLevelBlock(image);
      if (!seen.has(block)) {
        seen.add(block);
        imageBlocks.push(block);
      }
    });

    imageBlocks.forEach(function(block) {
      let previous = block.previousElementSibling;

      while (previous && previous.textContent.trim() === '' && !previous.querySelector('img')) {
        const empty = previous;
        previous = previous.previousElementSibling;
        empty.remove();
      }

      if (previous && /^H[1-4]$/.test(previous.tagName)) {
        body.insertBefore(block, previous);
      }
    });

    const hasHeroImage = Boolean(root.querySelector('.article-hero img'));
    const allowedBodyImages = hasHeroImage ? 2 : 3;
    const normalizedImages = [];
    const normalizedSeen = new Set();

    body.querySelectorAll('img').forEach(function(image) {
      const block = topLevelBlock(image);
      if (!normalizedSeen.has(block)) {
        normalizedSeen.add(block);
        normalizedImages.push(block);
      }
    });

    normalizedImages.slice(allowedBodyImages).forEach(function(block) {
      const images = block.querySelectorAll('img');
      const remainingText = block.textContent.trim();

      if (remainingText === '') {
        block.remove();
      } else {
        images.forEach(function(image) {
          image.remove();
        });
      }
    });
  }

  document.querySelectorAll('[id^="paleon-article-"]').forEach(normalizePaleonArticle);

  document.addEventListener('click', async function(event) {
    const button = event.target.closest('[data-paleon-copy-link]');
    if (!button) return;

    const label = button.querySelector('[data-copy-label]');
    const defaultText = button.dataset.defaultText || 'Copy link';
    const copiedText = button.dataset.copiedText || 'Link copied';
    const url = window.location.href;

    try {
      await navigator.clipboard.writeText(url);
    } catch (error) {
      const textarea = document.createElement('textarea');
      textarea.value = url;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      textarea.remove();
    }

    if (label) label.textContent = copiedText;
    window.setTimeout(function() {
      if (label) label.textContent = defaultText;
    }, 1800);
  });

  } catch(e) { console.error(e); }
})();
})();
